// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"285":"7a278e47","489":"c64eeeb6","506":"7a278e47","559":"7a278e47","818":"7a278e47","837":"c64eeeb6","887":"7a278e47"}[chunkId] + ".chunk.css";
};